import { useEffect, useState } from "react";
import "../component/ForgetModel/index.css";
import Icons from "../../../components/icons";
import { useAppServices } from "../../../hook/services";
import localforage from "localforage";

const Modal = ({ isOpen, onClose, children }) => {
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div
            className="modal-content-share text-center"
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

// Example usage in another component
const ResendEmailModal = ({ isModalOpen, justCloseIt, responseback, token }) => {
  const [processing, setProcessing] = useState(false);
  const Service = useAppServices();
  const [whitelabel, setwhitelabel] = useState("");
  const getting_whitelable_domain = async () => {
    // Extract the domain from the current page URL
    const currentURL = window.location.href; // Get the full URL of the current page
    const urlObject = new URL(currentURL); // Create a URL object
    const domain = urlObject.hostname; // Extract the hostname (domain)
    const payload = {
      domain: domain, // Use the extracted domain
      // domain: "maybe.my-business.link",
    };
    const { response, error } = await Service.agency.getwhitelabel({
      payload: payload,
    });
    if (response) {
      setwhitelabel(response.data);
    }
  };
  useEffect(() => {
    getting_whitelable_domain();
  }, []);

  // prompt payload states
  const [email, setemail] = useState();

  // error status
  const [emailError, setemailError] = useState(null);

  const handleClose = () => {
    justCloseIt();
  };
  const handleAddUserSubmit = async () => {
    setProcessing(true);
    setemailError(null);
    const currentURL = window.location.href; // Get the full URL of the current page
    const urlObject = new URL(currentURL); // Create a URL object
    const domain = urlObject.hostname;

    if (!email) {
      setemailError("Email is required");
    }
    try {
      const { response, error: respError } = await Service.auth.resendEmail({
        payload: {
          email: email,
          agency_id:
            whitelabel?._id || "6739f1be347a7f5974735cec",
          token
        },
      });
      if (response) {
        handleClose();
        responseback(`Verification email send to the ${email}`);
      }
      if (respError?.message === "User not found!") {
        setemailError(
          "We couldn't find an account with that email, please check for typos and try again"
        );
      } else if (respError?.message) setemailError(respError.message);
      setProcessing(false);
    } catch (error) {
      console.log("error", error);
      if (error?.response) {
        setemailError(error?.response?.data?.message);
      }
      setProcessing(false);
    }
  };

  return (
    <div>
      <Modal isOpen={isModalOpen}>
        <div className="scrollable-modal-content">
          <div style={{ position: "relative" }}>
            <p
              style={{
                position: "absolute",
                right: 0,
                width: "12px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            >
              X
            </p>

            <p className="modalText">Resend Verify Email</p>
            <div className="formGroup" style={{ marginBottom: "20px" }}>
              <label>Email</label>
              <input
                type="text"
                name="email"
                placeholder="Email"
                className="flex-1 modalInputs"
                value={email}
                onChange={(e) => {
                  setemail(e.target.value);
                  setemailError(null);
                }}
              />
              {emailError && (
                <small style={{ color: "red" }}>{emailError}</small>
              )}
            </div>

            <p
              className="disagreeBtn"
              style={{
                margin: 0,
                width: "100%",
                opacity: processing ? 0.6 : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              disabled={processing}
              onClick={handleAddUserSubmit}
            >
              {processing && <Icons id="spinner" color="black" />}
              Resend
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ResendEmailModal;
